import api from './index.js'

export function getSettlementList(params) {
  return api.get('/api/v1/settlements', { params })
}
